import React from 'react';
import { Route } from 'react-router-dom';
import { UNREGISTER, UNREGISTER_VEHICLE, UNREGISTER_VEHICLE_SUMMARY } from './paths';
import UnregisterVehicle from 'modules/UnregisterVehicle/UnregisterVehicle';
import UnregisterVehicleSummary from 'modules/UnregisterVehicle/UnregisterVehicleSummary/UnregisterVehicleSummary';
export default function UnregisterVehicleRoutes() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: UNREGISTER
  }, /*#__PURE__*/React.createElement(UnregisterVehicle, null)), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: UNREGISTER_VEHICLE(':tagNumber')
  }, /*#__PURE__*/React.createElement(UnregisterVehicle, null)), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: UNREGISTER_VEHICLE_SUMMARY
  }, /*#__PURE__*/React.createElement(UnregisterVehicleSummary, null)));
}